import DailyGenerationReport from './DailyGenerationReport'

export default DailyGenerationReport
